// This is used to retrieve status values about certain events that cannot be otherwise 
// detected due to window reloads
export var trackingStatusGet = function trackingStatusGet(prop) {
  var previousItemStr = window.sessionStorage.getItem('ga4Status') || '{}';
  var previousItems = JSON.parse(previousItemStr);
  return prop && (previousItems === null || previousItems === void 0 ? void 0 : previousItems[prop]) ? previousItems === null || previousItems === void 0 ? void 0 : previousItems[prop] : null;
}; // Used to set a tracking status that can be used on the next page load

export var trackingStatusSet = function trackingStatusSet(statusName, value) {
  var previousItemStr = window.sessionStorage.getItem('ga4Status') || '{}';
  var previousItems = JSON.parse(previousItemStr);
  previousItems[statusName] = value;
  window.sessionStorage.setItem('ga4Status', JSON.stringify(previousItems));
};